import { ChipTypes } from '@lib/components/Chip/Chip';
import { SsoIntegrationProviderTypeEnum } from 'graphql-common';

const PROVIDER_TYPE_CHIP_MAP: Record<
  SsoIntegrationProviderTypeEnum,
  ChipTypes
> = {
  [SsoIntegrationProviderTypeEnum.Saml]: ChipTypes.chipGray,
};

export default function getSsoProviderTypeChipType(
  providerType: SsoIntegrationProviderTypeEnum,
): ChipTypes {
  return PROVIDER_TYPE_CHIP_MAP[providerType] || ChipTypes.chipGray;
}
